import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "Validations";

export const getCascadeValues = async () => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetCascadeValues`
    );
};